module.exports = { baseURL: "https://develop.api.inspiringhopeandfreedom.com" }
